import * as React from "react";

function SvgLaunchDarklyEvents(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 269.1 236"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>
          {".LaunchDarklyEvents_svg__cls-1{fill:#17202d;fill-rule:evenodd}"}
        </style>
      </defs>
      <g id="LaunchDarklyEvents_svg__Layer_2" data-name="Layer 2">
        <g id="LaunchDarklyEvents_svg__Layer_1-2" data-name="Layer 1">
          <g id="LaunchDarklyEvents_svg__Mark">
            <path
              className="LaunchDarklyEvents_svg__cls-1"
              d="M130.1 236c62.9 0 114.1-52.9 114.1-118a125.68 125.68 0 00-1.5-18.4c.1 2 .3 4.1.3 6 0 57-44.8 103.3-99.9 103.3A97 97 0 0181 186.5c-7.8 6.6-13.3 11.6-29.3 16.8C72 223.2 99.9 236 130.1 236zm-87-130.4c0-57 44.8-103.3 99.9-103.3a108.46 108.46 0 0113.9 1.1A110.79 110.79 0 00130 0C67.1 0 15.9 52.9 15.9 118a133.49 133.49 0 007.6 43.3c6.9-7.2 18.4-14.9 25.9-18.7-4.5-11.7-6.3-23.5-6.3-37z"
            />
            <path
              className="LaunchDarklyEvents_svg__cls-1"
              d="M110.2 86.5c-20.1-7.1-39.5-1.4-48.6 2.2 14.3 7.5 23.2 16.4 28.8 24.3 5.5-8.2 17.9-24.1 19.8-26.5zm39.8 58.4a79.41 79.41 0 00-1-8 177.47 177.47 0 01-21.5 12.9c-1.2.6-2.4 1.2-3.7 1.8-2.1 1-4.2 2-6.4 2.9-.4.2-.9.4-1.3.6.3.8.7 1.7 1.1 2.7.3.8.7 1.7 1 2.7.3.8.6 1.7.9 2.6a49.51 49.51 0 011.7 5.4l.9 3.3c.3 1.1.5 2.2.8 3.3a87.82 87.82 0 012.4 19.7c0 1.5-.3 3.1-.4 4.6A59.18 59.18 0 00150 151v-1.3a10.87 10.87 0 00-.1-1.8 7.45 7.45 0 00.1-3z"
            />
            <path
              className="LaunchDarklyEvents_svg__cls-1"
              d="M254.6 16a84.6 84.6 0 0114.5 2.5c-22.8 58.9-66.4 93.6-99.3 112.3-4.1 2.3-7.1 3.9-11 5.9-.3-2.9-1.5-10-2.4-14.4a1.39 1.39 0 00-2.2-.8 216.6 216.6 0 01-48.8 27.9 2.27 2.27 0 00-1.2 3.1c.6 1.2 1.3 2.7 1.9 4-4.5 1.1-9.4 2.3-10.7 2.7-1.2-6.4-5.9-14.7-10.9-18.4 1.6-3 5.1-8.9 7.6-12.9.6-.9 1.2-1.9 1.8-2.9s1.2-1.8 1.8-2.8a380.67 380.67 0 0123.5-31.7c.6-.8 1.2-1.5 1.9-2.3s1.2-1.5 1.9-2.2c18.3-21.5 40.9-43.2 63.9-55.5a125.27 125.27 0 0147.6-14.4c-3.3 6-9.3 14.2-19.8 24a1.56 1.56 0 00-.6.8 6.71 6.71 0 00-.6 2.8c0 3.1 2.2 6.3 4.8 8.5 4 3.2 8.4 3.8 11.1 1.3l.8-.7c12.6-10.6 20.7-23 24.4-36.8zm-96.5 96.8a10.51 10.51 0 10-10.1-10.5 10.29 10.29 0 0010.1 10.5zm22.7-17.6a10.51 10.51 0 1110.1-10.5 10.29 10.29 0 01-10.1 10.5zm21.7-17.5a10.51 10.51 0 1110.1-10.5 10.29 10.29 0 01-10.1 10.5zM75.3 147c5.6.4 10.8 11 10.6 13.7-.2 3.5-1.6 9.4-11.6 19-.1.1-.2.1-.2.2l-.2.2c-7.7 7.3-18.4 12.2-29.6 15.6-.1 0-.2.1-.3.1s-.2 0-.2.1c-17.1 5-34.9 6.3-43.8 6.7a272.05 272.05 0 0127.7-31.4l.2-.2.2-.2c10.1-9.6 18.7-15.4 25.6-18.9.1 0 .1-.1.2-.1s.2-.1.3-.1c11.7-5.8 18.7-5 21-4.5 0-.2 0-.2.1-.2m-1 11.5a11 11 0 002.6-2.7c.1-.5-.5-.9-1.2-1.8-3.7-4.7-16.3.1-22 3.4-10 5.9-18.9 15.6-22.1 20-.1.1-.1.2-.2.3a.22.22 0 01-.2.2c-.7 1-1.1 1.5-1.1 1.5l1.2-1.2.2-.2.2-.2c4.2-3.9 15.5-13.9 23.9-16.3.9-.2-5.1 15-5.1 15s12.8-9.4 12.9-9.5c2.1-1.6 4.2-3.2 6.1-4.7.8-.6 1.6-1.2 2.3-1.8.9-.7 1.8-1.4 2.5-2z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgLaunchDarklyEvents);
